<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="pt-20 d-flex justify-center">
          <v-img slot="image" src="../../../assets/imgs/check.svg" width="100" height="100" contain />
        </v-col>
        <v-col cols="12" class="pt-6 pb-2">
          <span class="d-flex justify-center text-center headline primary--text font-weight-bold"> Operação Realizada com Sucesso</span>
        </v-col>
        <v-col cols="12" class="pt-0 pb-4">
          <span class="d-flex justify-center text-center pt-0" color="primary">Como deseja prosseguir? </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mt-auto pt-0">
          <v-btn class="mt-4 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="$emit('close', 'lista')" block outlined data-cy="listaSimulacao">Ver Simulações</v-btn>
          <v-btn class="mt-4 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="$emit('close', 'novo')" block outlined data-cy="novaSimulacao">Nova Simulação</v-btn>
          <v-btn class="mt-5 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="$emit('nextStep', 'prosseguir')" block data-cy="prosseguirProposta">Prosseguir para Proposta</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
    };
  }
}
</script>
